<!-- eslint-disable vue/multi-word-component-names -->
<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->
<template>
  <div class="finGLJournal-main">
    <div class="left-container" ref="leftContainer">
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="right-container">
      <div class="top-section">
        <div class="filter-description">{{ filterText }}</div>
        <ButtonFilter
          class="button-filter-component"
          filterPosition="right"
          buttonText="Change Filter"
          :filterWidth="300"
          :isOpen.sync="mainFilterIsOpen"
          :buttonIsDisabled="mainFilterIsDisabled"
        >
          <div class="filter-popup">
            <BoxContainer
              title="Date"
              :isCheckBox="true"
              style="margin-bottom: 5px"
              :isChecked.sync="filterDateInvList"
            >
              <div class="row-display">
                <DateTimePicker
                  :showTime="false"
                  placeholder="From"
                  :isDisabled="!filterDateInvList"
                  :value.sync="fromJournalListingDate"
                  :errorMessage.sync="fromJournalListingDateErr"
                  :showMonthOnly="true"
                />
                <DateTimePicker
                  :showTime="false"
                  placeholder="To"
                  :isDisabled="!filterDateInvList"
                  :value.sync="toJournalListingDate"
                  :errorMessage.sync="toJournalListingDateErr"
                  :showMonthOnly="true"
                />
              </div>
            </BoxContainer>
            <button @click="refreshClicked">Refresh</button>
          </div>
        </ButtonFilter>
      </div>
      <div class="bottom-section">
        <TableBox
          title="Journal"
          :tableData.sync="journalListing"
          :dataType="{ Total: 'currency', 'No of Entry': 'number' }"
          :hideColumns="['txnhdr','updind']"
          :selectedRow.sync="selectedJournal"
        />
      </div>
    </div>
    <PopupEntry
      v-if="popupShow"
      :show.sync="popupShow"
      :title="popupTitle"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
      :requiredError.sync="requiredError"
      :successMessages.sync="successMessages"
      :errorMessages="errorMessages"
      @save="saveClicked"
    >
      <div class="fingljournal-entries">
        <BoxContainer title="Journal Header" :isCollapsible="true" :isCollapsed.sync="journalHeaderCollapse">
          <div class="fingljournal-header">
            <div class="fingljournal-header-left">
              <div class="fingljournal-header-left-top">
                <Input
                  placeholder="Batch No"
                  :inputValue.sync="batchNo"
                  style="width: margin-right: 5px;"
                  :isDisabled="true"
                />
                <DateTimePicker
                  placeholder="Date"
                  :value.sync="batchDate"
                  :showMonthOnly="true"
                  :showTime="false"
                  :isRequired="true"
                  @dateChanged="getFyear($event)"
                  :isDisabled.sync="batchDateDisabled"
                />
                <Input placeholder="Period" :inputValue.sync="batchPeriod" :isDisabled="true" />
                <Input placeholder="Fyear" :inputValue.sync="fYear" :isDisabled="true" />
              </div>
              <div class="fingljournal-header-left-bottom">
                <Input
                  placeholder="Batch Name"
                  :inputValue.sync="batchName"
                  :isDisabled="viewMode"
                  validator="text,200"
                />
              </div>
            </div>
            <div class="fingljournal-header-right">
              <div class="fingljournal-header-right-top">
                <Input
                  placeholder="Accumulated Debit"
                  :inputValue.sync="accumulatedDebit"
                  style="margin-right: 5px"
                  :isDisabled="true"
                />
                <Input placeholder="Accumulated Credit" :inputValue.sync="accumulatedCredit" :isDisabled="true" />
              </div>
              <div class="fingljournal-header-right-bottom">
                <Input placeholder="No. of Entries" :inputValue.sync="noOfEntries" :isDisabled="true" />
              </div>
            </div>
          </div>
        </BoxContainer>
        <div class="fingljournal-body">
          <div class="fingljournal-body-table" :style="{ width: showEntriesInput ? '30%' : '100%' }">
            <div v-if="!viewMode" class="entries-button">
              <button style="margin-right: 5px" @click="addEntriesClicked">Add Entries</button>
              <button @click="deleteEntriesClicked">Delete Entries</button>
            </div>
            <div class="entries-table">
              <TableBox
                v-if="showEntriesData"
                title="Entries"
                :tableData="entriesData"
                :selectedRow.sync="selectedEntriesData"
                :additionalButtons="entriesButtons"
                @buttonClicked="entriesButtonClicked"
                :rowHeight="30"
                :dataType="{ 'Txn Date': 'date', Amount: 'currency', 'Taxable Amt': 'currency', 'Tax Rate': 'number' }"
                :hideColumns="[
                  'distid',
                  'updind',
                  'action',
                  'userid',
                  'usercreated',
                  'datecreated',
                  'seqno',
                  'dateupdated',
                  'batchno',
                  'Acc Desc',
                  'deptcode',
                  'distributeArr',
                ]"
                :columnOrderViews.sync="entriesTableBoxColumnOrderViews"
                :columnOrderID="entriesTableBoxColumnOrderID"
              />
            </div>
          </div>
          <div
            v-if="showEntriesInput"
            class="side-entries-open"
            :style="{ width: showEntriesInput ? 'calc(70% - 5px)' : '0%' }"
          >
            <div class="title-button">
              <b>{{ viewMode ? '' : entriesTitle }}</b>
              <div class="side-entries-buttons">
                <button v-if="!viewMode && !distributeCheck" style="margin-right: 5px" @click="addEditEntries">{{
                  entriesButtonTitle
                }}</button>
                <button
                  v-if="!viewMode && distributeCheck && !editingDistEntries"
                  @click="addEditDistributeEntries('N')"
                  style="margin-right: 5px"
                  >Add Dist Entries</button
                >
                <button
                  v-if="!viewMode && distributeCheck && editingDistEntries"
                  @click="addEditDistributeEntries('E')"
                  style="margin-right: 5px"
                  >Edit Dist Entries</button
                >
                <button
                  v-if="!viewMode && distributeCheck && !editingDistEntries"
                  @click="deleteDistributeEntries"
                  style="margin-right: 5px"
                  >Delete Dist Entries</button
                >
                <button
                  v-if="!viewMode && distributeCheck && !editingDistEntries"
                  @click="finishClicked"
                  style="margin-right: 5px"
                  >Finish</button
                >
                <button v-if="distributeCheck && editingDistEntries" @click="clearDistEntriesData">Cancel</button>
                <button v-if="!editingDistEntries" @click="showEntriesInput = !showEntriesInput">Cancel</button>
              </div>
            </div>
            <div class="body-entries-details">
              <div class="body-entries-details-main">
                <div class="body-entries-details-left">
                  <div class="entries-date" style="display: flex; flex-direction: row;">
                    <DateTimePicker
                      placeholder="Transaction Date"
                      :value.sync="transactionDate"
                      :errorMessage.sync="transactionDateErrMsg"
                      :showTime="false"
                      :isRequired="true"
                      :isDisabled="viewMode"
                    />
                    <CheckBoxV2
                      title="Distribute"
                      :isChecked.sync="distributeCheck"
                      :isDisabled="viewMode || distributeIsDisabled"
                      style="margin-left: 10px"
                    />
                  </div>
                  <div class="entries-debcre">
                    <div style="display: flex; flex-direction: column;">
                      <InputQuery
                        placeholder="Debit Account"
                        :items="glList"
                        itemKey="CodeDesc"
                        :selectedObject.sync="selectedDebitAcc"
                        :errorMessage.sync="selectedDebitAccErrMsg"
                        :isRequired="true"
                        :isDisabled="viewMode"
                        @selected="debitSelected"
                        style="width: 100%"
                      />
                      <InputQuery
                        placeholder="Credit Account"
                        :items="glList"
                        itemKey="CodeDesc"
                        :selectedObject.sync="selectedCreditAcc"
                        :errorMessage.sync="selectedCreditAccErrMsg"
                        :isRequired="true"
                        :isDisabled="viewMode"
                        @selected="creditSelected"
                        style="width: 100%"
                      />
                    </div>
                  </div>
                  <div class="entries-amount">
                    <div v-if="isTax" style="display: flex; flex-direction: row; width: 100%">
                      <Input
                        placeholder="Taxable Amount"
                        :inputValue.sync="taxableAmount"
                        validator="positiveCurrency"
                        :isDisabled="viewMode"
                        @focusChanged="amountChanges($event, 'taxableAmount')"
                        style="width: 30%; margin-right: 5px"
                      />
                      <InputQuery
                        placeholder="Tax Code"
                        :items="taxList"
                        itemKey="Tax Code"
                        :selectedObject.sync="selectedTaxCode"
                        :isDisabled="viewMode"
                        @selected="taxCodeSelected"
                        style="width: 50%; margin-right: 5px"
                      />
                      <Input
                        placeholder="Tax Rate %"
                        :inputValue.sync="taxRate"
                        style="width: 20%"
                        :isDisabled="true"
                      />
                    </div>
                    <div>
                      <!-- <Input placeholder="Amount" :inputValue.sync="amount" @inputChanged="amountChanges($event, 'amount')" /> -->
                      <Input
                        placeholder="Amount"
                        :inputValue.sync="amount"
                        :errorMessage.sync="amountErrMsg"
                        :isRequired="true"
                        validator="positiveCurrency"
                        :isDisabled="viewMode"
                        @focusChanged="amountChanges($event, 'amount')"
                      />
                    </div>
                  </div>
                </div>
                <div class="body-entries-details-right">
                  <div style="display: flex; flex-direction: row">
                    <Input
                      placeholder="Cheque No"
                      :inputValue.sync="chequeNo"
                      :isDisabled="viewMode"
                      validator="text,25"
                      style="margin-right: 5px"
                    />
                    <Input
                      placeholder="Receipt/Voucher No"
                      :inputValue.sync="receiptVoucherNo"
                      :isDisabled="viewMode"
                      validator="text,25,uppercase"
                    />
                  </div>
                  <div style="display: flex; flex-direction: row; width: 100%">
                    <InputQuery
                      placeholder="Cost Code"
                      :items="costCodeList"
                      itemKey="Cost Code"
                      :selectedObject.sync="selectedCostCode"
                      :isDisabled="viewMode"
                      style="width: 29%"
                    />
                    <InputQuery
                      placeholder="Vehicle No"
                      :items="vehicleList"
                      itemKey="Vehicle No"
                      :selectedObject.sync="selectedVehicleNo"
                      :isDisabled="viewMode"
                      style="width: 29%"
                    />
                    <Input
                      placeholder="Job No"
                      :inputValue.sync="jobNo"
                      :isDisabled="viewMode"
                      validator="text,25"
                      style="margin-right: 5px; width: 42%"
                    />
                  </div>
                  <div>
                    <RemarksBox title="Remarks" :text.sync="remarks" :maxLength="200" :isDisabled="viewMode" />
                  </div>
                </div>
              </div>
              <div v-if="distributeCheck" class="body-entries-details-distribute">
                <TableBox
                  v-if="showDistributeEntriesData"
                  title="Distribute Entries"
                  :tableData="distributeEntriesData"
                  :selectedRow.sync="selectedDistributeEntries"
                  :hideBottomBlock="true"
                  :additionalButtons="entriesButtons"
                  @buttonClicked="distributeEntriesButtonClicked"
                  :dataType="{ Amount: 'currency', 'Taxable Amt': 'currency', 'Tax Rate': 'number' }"
                  :rowHeight="30"
                  :hideColumns="['seqno']"
                  :columnOrderViews.sync="distributeEntriesTableBoxColumnOrderViews"
                  :columnOrderID="distributeEntriesTableBoxColumnOrderID"
                />
              </div>
              <div v-if="distributeCheck" class="body-entries-details-distribute-total">
                <Input placeholder="Total Debit" :inputValue.sync="totalDebit" :isDisabled="true" />
                <Input placeholder="Total Credit" :inputValue.sync="totalCredit" :isDisabled="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    entriesButtons() {
      return this.viewMode == true ? [{ text: 'View', index: 0, width: 60 }] : [{ text: 'Edit', index: 0, width: 60 }];
    },
  },
  data: function () {
    return {
      menu: [
        {
          title: 'New Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: false,
          key: 'mnuAddNew',
        },
        {
          title: 'New Tax Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: false,
          key: 'mnuAddNew',
        },
        {
          title: 'Edit Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          key: 'mnuNewTrans',
        },
        {
          title: 'Delete Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: false,
          key: 'mnuDelete',
        },
        {
          title: 'View Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
          key: 'mnuOpen',
        },
        {
          title: 'Print Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/Print.png',
          enabled: false,
          key: 'mnuJournalList', //need to add new record in settingsaccessmaster as mnuJournalListing is in different formID
        },
      ],
      filterText: '',
      mainFilterIsOpen: false,
      mainFilterIsDisabled: false,
      filterDateInvList: true,
      fromJournalListingDate: new Date(new Date().setMonth(new Date().getMonth() - 3)),
      fromJournalListingDateErr: '',
      toJournalListingDate: new Date(),
      toJournalListingDateErr: '',
      journalListing: [],
      selectedJournal: [],
      isTax: false,
      fYear: '',
      oriFYear: '',

      //region PopupEntry

      action: '',
      popupShow: false,
      popupTitle: '',
      createdBy: '',
      updatedBy: '',
      lastupdate: '',
      requiredError: [],
      successMessages: [],
      errorMessages: [],
      viewMode: false,
      batchNo: '',
      batchDate: null,
      batchDateDisabled: false,
      currentPeriod: '',
      batchPeriod: '',
      batchName: '',
      accumulatedDebit: '',
      accumulatedCredit: '',
      noOfEntries: '',
      entriesData: [],
      showEntriesData: true,
      selectedEntriesData: [],
      entriesTableBoxColumnOrderViews: [],
      entriesTableBoxColumnOrderID: null,
      showEntriesInput: false,
      journalHeaderCollapse: false,

      //endregion

      //region entries
      entriesAction: '',
      entriesTitle: '',
      entriesButtonTitle: '',
      transactionDate: null,
      distTransactionDate: null,
      transactionDateErrMsg: '',
      distributeCheck: false,
      distributeIsDisabled: false,
      glList: [],
      selectedDebitAcc: null,
      selectedDebitAccErrMsg: '',
      selectedCreditAcc: null,
      selectedCreditAccErrMsg: '',
      taxableAmount: '',
      taxList: [],
      selectedTaxCode: null,
      taxRate: '',
      amount: '',
      amountErrMsg: '',
      remarks: '',
      chequeNo: '',
      distChequeNo: '',
      receiptVoucherNo: '',
      distReceiptVoucherNo: '',
      jobNo: '',
      costCodeList: [],
      selectedCostCode: null,
      vehicleList: [],
      selectedVehicleNo: null,
      distributeEntriesData: [],
      selectedDistributeEntries: [],
      showDistributeEntriesData: true,
      distributeEntriesTableBoxColumnOrderViews: [],
      distributeEntriesTableBoxColumnOrderID: null,
      editingDistEntries: false,
      totalDebit: '0.00',
      totalCredit: '0.00',
      //endregion
    };
  },
  props: {},
  methods: {
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      this.menu.forEach((m) => {
        m.enabled = true;
        m.visible = true;
      });
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=FINGL&page=Journal Entry`);
      sasControl.forEach((k) => {
        //key in menu same as control value from api
        const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
      this.$fullscreenLoading('');
    },
    async menuClicked(e) {
      this.mainFilterIsOpen = false;

      switch (e['title']) {
        case 'New Journal':
          this.clearData();
          this.popupTitle = 'New Journal';
          this.batchNo = '**********';
          this.action = 'N';
          this.viewMode = false;
          this.popupShow = true;
          break;
        case 'New Tax Journal':
          this.clearData();
          this.popupTitle = 'New Tax Journal';
          this.batchNo = '**********';
          this.action = 'N';
          this.viewMode = false;
          this.isTax = true;
          this.distributeCheck = true;
          this.distributeIsDisabled = true;
          this.popupShow = true;
          break;
        case 'Edit Journal':
          if (this.selectedJournal.length == 0) {
            this.$showAlert('error', 'No Journal Selected', 'Please select a journal to edit');
            return;
          }
          if (this.selectedJournal[0]['Status'] == 'C') {
            this.$showAlert('error', 'Journal Cancelled', 'Journal already cancelled. Unable to edit');
            return;
          }

          if (['1', '2', '3'].includes(this.selectedJournal[0]['updind'])) {
            let msg = '';
            if (this.selectedJournal[0]['updind'] == '1') {
              msg = 'Journal already confirmed. ';
            } else if (this.selectedJournal[0]['updind'] == '2') {
              msg = 'Month end already closed. ';
            } else {
              msg = 'Year end already closed. ';
            }
            this.$showAlert('error', 'Journal Confirmed', `${msg}Unable to edit`);
            return;
          }
          this.clearData();
          await this.getJournalDetails();
          this.popupTitle = `Edit ${this.selectedJournal[0]['Tax'] == 'Yes' ? 'Tax ' : ''}Journal (${this.selectedJournal[0]['Batch No']})`;
          if (this.selectedJournal[0]['Tax'] == 'Yes') {
            this.isTax = true;
            this.distributeCheck = true;
            this.distributeIsDisabled = true;
          }
          this.action = 'E';
          this.viewMode = false;
          this.popupShow = true;
          break;
        case 'View Journal':
          if (this.selectedJournal.length == 0) {
            this.$showAlert('error', 'No Journal Selected', 'Please select a journal to view');
            return;
          }
          this.clearData();
          await this.getJournalDetails();
          this.popupTitle = `View ${this.selectedJournal[0]['Tax'] == 'Yes' ? 'Tax ' : ''}Journal (${this.selectedJournal[0]['Batch No']})`;
          this.viewMode = true;
          this.popupShow = true;
          return;
        case 'Delete Journal':
          if (this.selectedJournal.length == 0) {
            this.$showAlert('error', 'No Journal Selected', 'Please select a journal to delete');
            return;
          }

          await this.deleteClicked();
          break;
        case 'Print Journal': {
          const printJournalURL = `/Home/${this.$route.params.user}/FINGL/Print Journal`; //might be different based on if select a journal
          const resolvedPrintJournalRoute = this.$router.resolve(printJournalURL);
          window.open(resolvedPrintJournalRoute.href, '_blank'); //open in a new tab
          break;
        }
      }
    },
    async refreshClicked() {
      let errorJournalListing = false;
      if (!this.fromJournalListingDate) {
        this.fromJournalListingDateErr = 'Enter from date!';
        errorJournalListing = true;
      }
      if (!this.toJournalListingDate) {
        this.toJournalListingDateErr = 'Enter to date!';
        errorJournalListing = true;
      }
      if (this.fromJournalListingDate.getTime() > this.toJournalListingDate.getTime()) {
        this.fromJournalListingDateErr = 'From Date > To Date';
        this.toJournalListingDateErr = 'From Date > To Date';
        errorJournalListing = true;
      }

      if (errorJournalListing) {
        return;
      }
      await this.getJournalListing();
      this.mainFilterIsOpen = false;
    },
    async getJournalListing() {
      this.$fullscreenLoading('Getting Journal');
      this.selectedJournal = [];
      this.journalListing = [];
      const monthFirstDay = new Date(
        this.fromJournalListingDate.getFullYear(),
        this.fromJournalListingDate.getMonth(),
        1,
      );
      const monthLastDay = new Date(
        this.toJournalListingDate.getFullYear(),
        this.toJournalListingDate.getMonth() + 1,
        0,
      );
      const postBody = {
        masterfile: 'JOURNAL',
        taxjournal: '0',
        startdate: monthFirstDay.formatString('yyyy-MM-dd') ?? '',
        enddate: monthLastDay.formatString('yyyy-MM-dd') ?? '',
      };
      this.journalListing = await this.$apiCallV2('/FINGLJournal/GetFINGLList', postBody);
      this.$fullscreenLoading('');
    },
    async getJournalDetails() {
      const postBody = {
        batchno: this.selectedJournal[0]['Batch No'],
        fyear: this.selectedJournal[0]['FYear'],
      };
      this.$fullscreenLoading('Getting Journal Details');
      const journalDetail = (await this.$apiCallV2('/FINGLJournal/GetFINGLJournal', postBody))['Journal']['TxnHdr'];
      this.createdBy = `${this.selectedJournal[0]['Created By']} ${this.selectedJournal[0]['Date Created']}`;
      this.updatedBy = `${journalDetail['userid']} ${journalDetail['dateupdate']}`;
      this.lastupdate = journalDetail['dateupdate'];
      this.batchNo = journalDetail['batchno'];
      // this.batchDate = journalDetail['sysdate'] ? new Date(journalDetail['sysdate']).formatString('MM/yyyy') : '';
      this.batchDate = journalDetail['sysdate'] ? new Date(journalDetail['sysdate']) : null;
      this.batchPeriod = journalDetail['period'];
      this.fYear = journalDetail['fyear'];
      await this.getGLList();
      this.batchName = journalDetail['batchname'];
      this.accumulatedDebit = journalDetail['accdebit'];
      this.accumulatedCredit = journalDetail['acccredit'];
      this.noOfEntries = journalDetail['noofentry'];

      const columnOrder = this.entriesTableBoxColumnOrderViews;
      const columnOrderID = this.entriesTableBoxColumnOrderID;

      this.entriesData = [];
      this.entriesTableBoxColumnOrderViews = [];
      this.entriesTableBoxColumnOrderID = null;
      let entriesDataTemp = [];

      if (journalDetail['TxnDet']) {
        entriesDataTemp = journalDetail['TxnDet'].filter((f) => f['distid'] == '0');

        if (journalDetail['TxnDet'].some((s) => s['distid'] != '0')) {
          //check if there is any record with distid <> 0 then means is a distribution record.
          const distinctDistId = new Set(journalDetail['TxnDet'].map((m) => m['distid']));
          //delete 0
          distinctDistId.delete('0');

          for (const distid of distinctDistId) {
            const filterDistArr = journalDetail['TxnDet'].filter((f) => f['distid'] == distid);
            const getTotal = filterDistArr.filter((f) => f['Debit Acc'] != '0');
            const totalAmount = getTotal.map((m) => Number(m['Amount'])).reduce((a, b) => a + b, 0);
            const totalTaxableAmount = getTotal.map((m) => Number(m['Taxable Amt'])).reduce((a, b) => a + b, 0);

            const firstDistRecord = journalDetail['TxnDet'].find((f) => f['distid'] == distid);
            let distseq = 0;
            firstDistRecord['distributeArr'] = filterDistArr.map((m) => {
              return {
                '#': ++distseq,
                'Credit Acc': m['Credit Acc'],
                'Debit Acc': m['Debit Acc'],
                Amount: m['Amount'],
                'Job No': m['Job No'],
                Remarks: m['Remarks'],
                'Cost Code': m['Cost Code'],
                'Vehicle No': m['Vehicle No'],
                'Taxable Amt': m['Taxable Amt'],
                'Tax Code': m['Tax Code'],
                'Tax Rate': m['Tax Rate'],
                'Acc Desc': m['Acc Desc'],
                seqno: m['seqno'],
              };
            });
            firstDistRecord['Debit Acc'] = '';
            firstDistRecord['Credit Acc'] = '';
            firstDistRecord['Amount'] = totalAmount.toString();
            firstDistRecord['Taxable Amt'] = totalTaxableAmount.toString();
            entriesDataTemp.push(firstDistRecord);
          }
        }

        entriesDataTemp.sort((a, b) => Number(a.seqno) - Number(b.seqno));
        let entriesSeq = 0;
        entriesDataTemp.forEach((f) => {
          f['#'] = ++entriesSeq;
        });
      }
      // const columnOrderID = {
      //   formname: 'FRMJOURNALENTRY',
      //   formctrlname: 'JournalEntries'
      // };
      // const columnOrder = await this.$apiCallV2('/TableBox/GetColumnOrder', columnOrderID);
      // console.log('columnorder', columnOrder);
      this.entriesData = entriesDataTemp;
      this.entriesTableBoxColumnOrderViews = columnOrder;
      this.entriesTableBoxColumnOrderID = columnOrderID;
      //to disable date field if there is entries
      if (this.entriesData.length > 0) {
        this.batchDateDisabled = true;
      } else {
        this.batchDateDisabled = false;
      }
      this.$fullscreenLoading('');
    },
    addEntriesClicked() {
      if (!this.batchDate) {
        this.$showAlert('error', 'Journal Date Missing', 'Please key in Journal Date before Adding Entries');
        return;
      }
      this.clearEntriesData();
      this.entriesAction = 'N';
      this.entriesTitle = 'Add Entries';
      this.entriesButtonTitle = 'Add Entries';

      this.showEntriesInput = true;
    },
    async deleteEntriesClicked() {
      if (this.selectedEntriesData.length == 0) {
        this.$showAlert('error', 'No Entries Selected', 'Please select an entries to delete');
        return;
      }

      const confirmDelete = await this.$showAlert(
        'warning',
        'Deleting Entries',
        'Are you sure you want to delete the selected entries?',
        [
          { text: 'Yes', color: 'indianred', textColor: 'white' },
          { text: 'No', color: 'lightgray', textColor: 'black' },
        ],
      );
      if (confirmDelete == 'No') {
        return;
      }
      const tempData = this.entriesData;

      this.selectedEntriesData.forEach((e) => {
        const index = tempData.findIndex((f) => f['seqno'] == e['seqno']);
        tempData.splice(index, 1);
      });

      // this.entriesData = [];
      // this.selectedEntriesData = [];
      this.updateEntriesTableData(tempData);
      this.$nextTick(() => {
        // this.entriesData = tempData;
        if (this.entriesData.length > 0) {
          this.batchDateDisabled = true;
        } else {
          this.batchDateDisabled = false;
        }
        this.calculateAccumulated();
      });
    },
    entriesButtonClicked(btn, data) {
      this.clearEntriesData();
      this.selectedEntriesData = [data];

      if (btn === 'Edit') {
        this.entriesTitle = 'Edit Entries';
        this.entriesButtonTitle = 'Edit Entries';
      } else if (btn === 'View') {
        this.entriesTitle = 'View Entries';
        this.entriesButtonTitle = '';
      }

      this.distributeCheck = data['distributeArr'] && data['distributeArr'].length > 0;
      if (!this.distributeCheck) {
        this.transactionDate = data['Txn Date'] ? new Date(data['Txn Date']) : null;
        this.selectedDebitAcc = this.glList.getSelected(data['Debit Acc'], 'Account Code');
        this.selectedCreditAcc = this.glList.getSelected(data['Credit Acc'], 'Account Code');
        this.taxableAmount = data['Taxable Amt'];
        this.selectedTaxCode = this.taxList.getSelected(data['Tax Code'], 'Tax Code');
        this.taxRate = data['Tax Rate'];
        this.amount = data['Amount'];
        this.remarks = data['Remarks'];
        this.chequeNo = data['Chq No'];
        this.receiptVoucherNo = data['Voucher No'];
        this.jobNo = data['Job No'];
        this.selectedCostCode = this.costCodeList.getSelected(data['Cost Code'], 'Cost Code');
        this.selectedVehicleNo = this.vehicleList.getSelected(data['Vehicle No'], 'Vehicle No');
      } else {
        this.distTransactionDate = data['Txn Date'] ? new Date(data['Txn Date']) : null;
        this.distChequeNo = data['Chq No'];
        this.distReceiptVoucherNo = data['Voucher No'];
        this.distributeEntriesData = JSON.parse(JSON.stringify(data['distributeArr']));
        this.calculateDistTotal();
      }

      this.distributeIsDisabled = true;
      this.showEntriesInput = true;
    },
    distributeEntriesButtonClicked(_btn, data) {
      this.clearDistEntriesData();
      this.selectedDistributeEntries = [data];
      this.editingDistEntries = true;
      this.transactionDate = this.distTransactionDate;
      this.selectedDebitAcc = this.glList.getSelected(data['Debit Acc'], 'Account Code');
      this.selectedCreditAcc = this.glList.getSelected(data['Credit Acc'], 'Account Code');
      this.taxableAmount = data['Taxable Amt'];
      this.selectedTaxCode = this.taxList.getSelected(data['Tax Code'], 'Tax Code');
      this.taxRate = data['Tax Rate'];
      this.amount = data['Amount'];
      this.remarks = data['Remarks'];
      this.chequeNo = this.distChequeNo;
      this.receiptVoucherNo = this.distReceiptVoucherNo;
      this.jobNo = data['Job No'];
      this.selectedCostCode = this.costCodeList.getSelected(data['Cost Code'], 'Cost Code');
      this.selectedVehicleNo = this.vehicleList.getSelected(data['Vehicle No'], 'Vehicle No');
    },
    clearData() {
      this.action = '';
      this.popupTitle = '';
      this.createdBy = '';
      this.updatedBy = '';
      this.lastupdate = '';
      this.requiredError = [];
      this.successMessages = [];
      this.errorMessages = [];
      this.isTax = false;
      this.fYear = '';
      // this.oriFYear = '';
      this.batchNo = '';
      this.batchDate = null;
      this.batchDateDisabled = false;
      this.currentPeriod = '';
      this.batchPeriod = '';
      this.batchName = '';
      this.accumulatedDebit = '';
      this.accumulatedCredit = '';
      this.noOfEntries = '';
      this.entriesData = [];
      this.selectedEntriesData = [];

      this.viewMode = false;
      this.journalHeaderCollapse = false;
      this.showEntriesInput = false;
      this.distributeCheck = false;
      this.distributeIsDisabled = false;
    },
    clearEntriesData() {
      this.entriesAction = '';
      this.entriesTitle = '';
      this.entriesButtonTitle = '';
      this.distEntriesButtonTitle = '';
      this.transactionDate = this.batchDate ? new Date(`${this.batchDate.formatString('yyyy-MM')}-01`) : null;
      this.transactionDateErrMsg = '';
      if (!this.isTax) {
        this.distributeCheck = false;
        this.distributeIsDisabled = false;
      } else {
        this.distributeIsDisabled = true;
      }
      this.selectedDebitAcc = null;
      this.selectedDebitAccErrMsg = '';
      this.selectedCreditAcc = null;
      this.selectedCreditAccErrMsg = '';
      this.taxableAmount = '';
      this.selectedTaxCode = null;
      this.taxRate = '';
      this.amount = '';
      this.amountErrMsg = '';
      this.remarks = '';
      this.chequeNo = '';
      this.receiptVoucherNo = '';
      this.jobNo = '';
      this.selectedCostCode = null;
      this.selectedVehicleNo = null;
      this.distributeEntriesData = [];
      this.selectedDistributeEntries = [];
      this.editingDistEntries = false;
      this.totalDebit = '0.00';
      this.totalCredit = '0.00';

      this.distTransactionDate = null;
      this.distChequeNo = '';
      this.distReceiptVoucherNo = '';
    },
    clearDistEntriesData() {
      this.transactionDate = this.batchDate ? new Date(`${this.batchDate.formatString('yyyy-MM')}-01`) : null;
      this.transactionDateErrMsg = '';
      this.selectedDebitAcc = null;
      this.selectedDebitAccErrMsg = '';
      this.selectedCreditAcc = null;
      this.selectedCreditAccErrMsg = '';
      this.taxableAmount = '';
      this.selectedTaxCode = null;
      this.taxRate = '';
      this.amount = '';
      this.amountErrMsg = '';
      this.remarks = '';
      this.chequeNo = '';
      this.receiptVoucherNo = '';
      this.jobNo = '';
      this.selectedCostCode = null;
      this.selectedVehicleNo = null;
      this.editingDistEntries = false;
      this.selectedDistributeEntries = [];
    },
    calculateAccumulated() {
      let totalDebit = 0;
      if (this.entriesData && this.entriesData.length > 0) {
        totalDebit = this.entriesData
          .filter((f) => f['Debit Acc'] != '0')
          .map((m) => Number(m['Amount']))
          .reduce((a, b) => a + b, 0);
      }
      this.accumulatedDebit = totalDebit.toFixed(2);

      let totalCredit = 0;
      if (this.entriesData && this.entriesData.length > 0) {
        totalCredit = this.entriesData
          .filter((f) => f['Credit Acc'] != '0')
          .map((m) => Number(m['Amount']))
          .reduce((a, b) => a + b, 0);
      }
      this.accumulatedCredit = totalCredit.toFixed(2);

      let totalEntries = 0;
      if (this.entriesData && this.entriesData.length > 0) {
        totalEntries = this.entriesData.filter((f) => f['distid'] == '0').length;
        const distEntries = this.entriesData.filter((f) => f['distid'] != '0');
        distEntries.forEach((f) => {
          totalEntries += f['distributeArr'].length;
        });
      }
      this.noOfEntries = totalEntries.toString();
    },
    calculateDistTotal() {
      this.totalDebit = this.distributeEntriesData
        .filter((f) => f['Debit Acc'] && f['Debit Acc'] != '0')
        .map((m) => Number(m['Amount']))
        .reduce((a, b) => a + b, 0)
        .toFixed(2);

      this.totalCredit = this.distributeEntriesData
        .filter((f) => f['Credit Acc'] && f['Credit Acc'] != '0')
        .map((m) => Number(m['Amount']))
        .reduce((a, b) => a + b, 0)
        .toFixed(2);
    },
    async getFyear(newDate) {
      this.$fullscreenLoading('Checking Financial Year');
      this.fYear = '';
      this.batchPeriod = '';
      let date = null;
      if (newDate) {
        date = newDate;
        const result = await this.$apiCallV2('/FINGLJournal/GetFINGLList', {
          masterfile: 'FYEAR',
          txndate: date.formatString('yyyy-MM-dd'),
        });
        this.fYear = result[0]['fyear'];
        this.showEntriesInput = false;
      }

      if (this.fYear) {
        const validateFyear = await this.getYearEnd(this.fYear);
        if (!validateFyear.validFyear) {
          this.$fullscreenLoading('');
          this.$showAlert(
            'error',
            `Invalid Financial Year(${this.fYear})`,
            'Please generate new year or check with administrator',
          );
          this.batchDate = null;
          this.batchPeriod = '';
          this.fYear = '';
          return;
        }
        if (validateFyear.yearEnd) {
          this.$fullscreenLoading('');
          this.$showAlert(
            'error',
            'Year End Processed',
            `No journal entry allowed for this financial year(${this.fYear})`,
          );
          this.batchDate = null;
          this.batchPeriod = '';
          this.fYear = '';
          return;
        }
        await this.getPeriod(this.fYear, this.batchDate);

        await this.getGLList();
      }
      this.$fullscreenLoading('');
    },
    async getGLList() {
      this.$fullscreenLoading('Getting GL List');
      if (this.fYear !== this.oriFYear) {
        this.oriFYear = this.fYear;
        this.glList = [];
        const tempGLList = await this.$apiCallV2('/FINGLJournal/GetFINGLList', {
          masterfile: 'GLMASTER',
          fyear: this.fYear,
        });
        if (tempGLList) {
          tempGLList.forEach(f => {
            f['CodeDesc'] = `${f['Account Code']} - ${f['Account Name'] ?? ''}`;
          });
        }
        this.glList = tempGLList;
      }
      this.$fullscreenLoading('');
    },
    async getYearEnd(fYear) {
      let validFyear = false;
      let yearEnd = false;
      const result = await this.$apiCallV2('/FINGLJournal/GetFINGLList', { masterfile: 'CHECKYEAREND', fyear: fYear });
      if (result && result.length > 0) {
        validFyear = true;
        this.currentPeriod = result[0]['period'];
        if (result[0]['period'] == '13') {
          yearEnd = true;
        }
      }

      return { validFyear, yearEnd };
    },
    async getPeriod(fYear, txnDate) {
      const result = await this.$apiCallV2('/FINGLJournal/GetFINGLList', {
        masterfile: 'PERIOD',
        fyear: fYear,
        txndate: txnDate.formatString('yyyy-MM-dd'),
      });
      this.batchPeriod = result[0]['period'];
    },
    entriesChecking() {
      let checking = false;
      this.transactionDateErrMsg = '';
      this.selectedDebitAccErrMsg = '';
      this.selectedCreditAccErrMsg = '';
      this.amountErrMsg = '';
      if (!this.transactionDate) {
        this.transactionDateErrMsg = 'Enter Transaction Date';
        checking = true;
      } else if (this.transactionDate.formatString('yyyy-MM') != this.batchDate.formatString('yyyy-MM')) {
        this.transactionDateErrMsg = `Batch Month and year(${this.batchDate.formatString('yyyy-MM')}) must be same with transaction date`;
        checking = true;
      }
      if (!this.selectedDebitAcc) {
        this.selectedDebitAccErrMsg = 'Select a Debit Acc';
        checking = true;
      }
      if (!this.selectedCreditAcc) {
        this.selectedCreditAccErrMsg = 'Select a Credit Acc';
        checking = true;
      }
      if (!this.amount) {
        this.amountErrMsg = 'Enter amount';
        checking = true;
      }

      return checking;
    },
    addEditEntries() {
      const checking = this.entriesChecking();
      if (checking) {
        return;
      }

      let entAction = '';
      if (this.entriesButtonTitle.includes('Add')) {
        entAction = 'N';
      } else {
        entAction = 'E';
      }

      if (!this.distributeCheck) {
        const tempData = this.entriesData;
        this.entriesAction =
          this.action == 'N' ? 'N'
          : this.selectedEntriesData['action'] == 'N' ? 'N'
          : 'E';
        //entriesAction check on this to see certain key object to use the original data
        const entriesDataObj = {
          '#':
            entAction == 'N' ?
              tempData.length > 0 ?
                Math.max(...tempData.map((m) => Number(m['#']))) + 1
              : 1
            : this.selectedEntriesData[0]['#'],
          'Txn Date': this.transactionDate.formatString('yyyy-MM-dd'),
          'Chq No': this.chequeNo,
          'Voucher No': this.receiptVoucherNo,
          'Debit Acc': this.selectedDebitAcc['Account Code'],
          'Credit Acc': this.selectedCreditAcc['Account Code'],
          Amount: this.amount,
          'Job No': this.jobNo,
          Remarks: this.remarks,
          'Cost Code': this.selectedCostCode ? this.selectedCostCode['Cost Code'] : '',
          'Vehicle No': this.selectedVehicleNo ? this.selectedVehicleNo['Vehicle No'] : '',
          'Taxable Amt': this.isTax && this.taxableAmount ? this.taxableAmount : '0.00',
          'Tax Code': this.selectedTaxCode ? this.selectedTaxCode['Tax Code'] : '',
          'Tax Rate': this.taxRate,
          'Acc Desc': '',
          distid: '0',
          updind: '',
          action: this.entriesAction,
          userid: '',
          seqno:
            entAction == 'N' ?
              tempData.length > 0 ?
                Math.max(...tempData.map((m) => Number(m['seqno']))) + 1
              : 1
            : this.selectedEntriesData[0]['seqno'],
          dateupdated: '',
          batchno: '',
        };

        if (entAction == 'E' && this.selectedEntriesData.length > 0) {
          const index = tempData.findIndex((item) => item['seqno'] == this.selectedEntriesData[0]['seqno']);
          tempData.splice(index, 1, entriesDataObj);
        } else {
          tempData.push(entriesDataObj);
        }

        // const columnOrder = this.entriesTableBoxColumnOrderViews;
        // const columnOrderID = this.entriesTableBoxColumnOrderID;
        // this.showEntriesData = false;
        // this.entriesData = [];
        // this.entriesTableBoxColumnOrderViews = [];
        // this.entriesTableBoxColumnOrderID = null;

        this.updateEntriesTableData(tempData);
        this.$nextTick(() => {
          // this.entriesData = tempData;
          // this.entriesTableBoxColumnOrderViews = columnOrder;
          // this.entriesTableBoxColumnOrderID = columnOrderID;
          // this.showEntriesData = true; //added due to table not rendering with latest changes
          this.batchDateDisabled = true;
          this.calculateAccumulated();

          if (entAction == 'N') {
            this.clearEntriesData();
            this.entriesAction = 'N';
            this.entriesTitle = 'Add Entries';
            this.entriesButtonTitle = 'Add Entries';
          } else {
            this.showEntriesInput = false;
          }
        });
      }
    },
    addEditDistributeEntries(action) {
      const checking = this.entriesChecking();
      if (checking) {
        return;
      }

      this.distTransactionDate = this.transactionDate;
      this.distChequeNo = this.chequeNo;
      this.distReceiptVoucherNo = this.receiptVoucherNo;

      const tempDistData = this.distributeEntriesData;

      const distEntriesDataObj = {
        '#':
          action == 'N' ?
            tempDistData.length > 0 ?
              Math.max(...tempDistData.map((m) => Number(m['#']))) + 1
            : 1
          : this.selectedDistributeEntries[0]['#'],
        'Credit Acc': this.selectedCreditAcc['Account Code'],
        'Debit Acc': this.selectedDebitAcc['Account Code'],
        Amount: this.amount,
        'Job No': this.jobNo,
        Remarks: this.remarks,
        'Cost Code': this.selectedCostCode ? this.selectedCostCode['Cost Code'] : '',
        'Vehicle No': this.selectedVehicleNo ? this.selectedVehicleNo['Vehicle No'] : '',
        'Taxable Amt': this.taxableAmount,
        'Tax Code': this.selectedTaxCode ? this.selectedTaxCode['Tax Code'] : '',
        'Tax Rate': this.taxRate,
        'Acc Desc': '',
        seqno: '',
      };

      if (action == 'E' && this.selectedDistributeEntries.length > 0) {
        const index = tempDistData.findIndex((item) => item['#'] == this.selectedDistributeEntries[0]['#']);
        tempDistData.splice(index, 1, distEntriesDataObj);
        this.editingDistEntries = false;
      } else {
        tempDistData.push(distEntriesDataObj);
      }

      // this.distributeEntriesData = [];
      this.updateDistEntriesTableData(tempDistData);
      this.$nextTick(() => {
        // this.distributeEntriesData = tempDistData;
        // this.selectedDistributeEntries = [];
        this.calculateDistTotal();
      });
    },
    async deleteDistributeEntries() {
      if (this.selectedDistributeEntries.length == 0) {
        this.$showAlert('error', 'No Distribute Entries Selected', 'Please select an entries to delete');
        return;
      }

      const confirmDelete = await this.$showAlert(
        'warning',
        'Deleting Distribute Entries',
        'Are you sure you want to delete the selected entries?',
        [
          { text: 'Yes', color: 'indianred', textColor: 'white' },
          { text: 'No', color: 'lightgray', textColor: 'black' },
        ],
      );
      if (confirmDelete == 'No') {
        return;
      }

      const tempData = this.distributeEntriesData;

      this.selectedDistributeEntries.forEach((e) => {
        const index = tempData.findIndex((f) => f['#'] == e['#']);
        tempData.splice(index, 1);
      });

      // this.distributeEntriesData = [];
      // this.selectedDistributeEntries = [];
      this.updateDistEntriesTableData(tempData);
      this.$nextTick(() => {
        // this.distributeEntriesData = tempData;
        this.calculateDistTotal();
      });
    },
    async saveClicked() {
      this.$fullscreenLoading('Saving Journal');
      this.errorMessages = [];
      this.successMessages = [];
      this.requiredError = [];

      let currentSeqNo = 1;
      let fullEntriesData = [];
      this.entriesData.forEach((ed) => {
        if (!ed['distributeArr'] || ed['distributeArr'].length == 0) {
          //normal entries
          fullEntriesData.push({
            seqno: currentSeqNo,
            debitac: ed['Debit Acc'],
            creditac: ed['Credit Acc'],
            txndate: ed['Txn Date'],
            chequeno: ed['Chq No'],
            receiptno: ed['Voucher No'],
            txnamount: ed['Amount'],
            remarks: ed['Remarks'],
            distid: ed['distid'],
            jobno: ed['Job No'],
            costcode: ed['Cost Code'],
            vehiclecode:
              ed['Vehicle No'] ? this.vehicleList.getSelected(ed['Vehicle No'], 'Vehicle No')['Vehicle Code'] : '',
            taxableamt: ed['Taxable Amt'],
            gst2taxcode: ed['Tax Code'],
            gst2taxrate: ed['Tax Rate'],
          });
          currentSeqNo++;
        } else if (ed['distributeArr'] || ed['distributeArr'].length > 0) {
          //distribute entries
          const distSeqNo = currentSeqNo;
          const distArray = ed['distributeArr'].map((m) => {
            return {
              seqno: currentSeqNo++,
              debitac: m['Debit Acc'],
              creditac: m['Credit Acc'],
              txndate: ed['Txn Date'],
              chequeno: ed['Chq No'],
              receiptno: ed['Voucher No'],
              txnamount: m['Amount'],
              remarks: m['Remarks'],
              distid: distSeqNo,
              jobno: m['Job No'],
              costcode: m['Cost Code'],
              vehiclecode:
                m['Vehicle No'] ? this.vehicleList.getSelected(m['Vehicle No'], 'Vehicle No')['Vehicle Code'] : '',
              taxableamt: m['Taxable Amt'],
              gst2taxcode: m['Tax Code'],
              gst2taxrate: m['Tax Rate'],
            };
          });
          fullEntriesData = [...fullEntriesData, ...distArray];
        }
      });

      const saveJson = {
        fyear: this.fYear,
        batchno: this.batchNo,
        date: this.batchDate ? this.batchDate.formatString('MM/yyyy') : '',
        batchname: this.batchName,
        accumulateddebit: this.accumulatedDebit,
        accumulatedcredit: this.accumulatedCredit,
        noofentries: this.noOfEntries,
        hdrtxn: '',
        action: this.action,
        reusebatchno: '',
        lastupdate: this.lastupdate,
        transaction: fullEntriesData,
      };

      const result = await this.$apiCallV2('/FINGLJournal/SaveFINGLJournal', saveJson);
      this.$fullscreenLoading('');
      if (result[0]['Results'] != '0') {
        this.errorMessages.push(
          `There was an error ${this.action == 'N' ? 'creating' : 'editing'} journal: ${result[0]['ErrMsg']}`,
        );
        return;
      }

      this.successMessages.push(`${result[0]['ErrMsg']}`);
      if (this.action == 'N') {
        this.batchNo = result[0]['batchno'];
      }
      this.viewMode = true;
      this.popupTitle = `View ${this.isTax ? 'Tax ' : ''}Journal`;
      this.action = '';
      const temp = this.entriesData;
      // this.entriesData = [];
      // this.$nextTick(() => {
      //   this.entriesData = temp;
      // });
      this.updateEntriesTableData(temp);
      await this.getJournalListing();
    },
    async deleteClicked() {
      if (this.selectedJournal[0]['Status'] == 'C') {
        this.$showAlert('error', 'Unable To Delete Journal', 'Journal already cancelled');
        return;
      }
      if (!['0', '11', '12'].includes(this.selectedJournal[0]['txnhdr'])) {
        this.$showAlert('error', 'Unable To Delete Journal', 'Delete not allowed for direct posting transactions');
        return;
      }
      if (['1', '2', '3'].includes(this.selectedJournal[0]['updind'])) {
        let msg = '';
        if (this.selectedJournal[0]['updind'] == '1') {
          msg = 'Journal already confirmed. ';
        } else if (this.selectedJournal[0]['updind'] == '2') {
          msg = 'Month end already closed. ';
        } else {
          msg = 'Year end already closed. ';
        }
        this.$showAlert('error', 'Journal Confirmed', `${msg}Unable to delete`);
        return;
      }

      const confirmDelete = await this.$showAlert(
        'warning',
        'Delete Journal',
        'Are you sure you want to delete Journal?',
        [
          { text: 'Yes', color: 'indianred', textColor: 'white' },
          { text: 'No', color: 'lightgray', textColor: 'black' },
        ],
      );
      if (confirmDelete == 'No') {
        return;
      }

      const reUseBatchNo = await this.$showAlert('warning', 'Delete Journal', 'Do you want to reuse the Batch No?', [
        { text: 'Yes', color: 'indianred', textColor: 'white' },
        { text: 'No', color: 'lightgray', textColor: 'black' },
      ]);

      this.$fullscreenLoading('Deleting Journal');

      const delBatchNo = this.selectedJournal[0]['Batch No'];
      const deleteJson = {
        action: 'D',
        batchno: delBatchNo,
        fyear: this.selectedJournal[0]['FYear'],
        hdrtxn: this.selectedJournal[0]['txnhdr'],
        reusebatchno: reUseBatchNo == 'Yes' ? 'Y' : 'N',
      };

      const result = await this.$apiCallV2('/FINGLJournal/SaveFINGLJournal', deleteJson);
      if (result[0]['Results'] == '1') {
        this.$showAlert('error', 'Delete Journal Failed', `${result[0]['ErrMsg']}`);
      } else {
        await this.getJournalListing();
        this.$showAlert('success', 'Delete Journal Successful', `${result[0]['ErrMsg']}`);
      }
      this.$fullscreenLoading('');
    },
    taxCodeSelected(newTaxCode) {
      if (newTaxCode) {
        this.taxRate = newTaxCode['Tax Rate'];
      } else {
        this.taxRate = '';
      }
    },
    amountChanges(value, from) {
      if (this.amount) {
        this.amount = Number(this.amount).toFixed(2);
      }
      if (this.taxableAmount) {
        this.taxableAmount = Number(this.taxableAmount).toFixed(2);
      }

      if (value == false) {
        if (from == 'amount' && this.taxRate && this.amount) {
          this.taxableAmount = (Number(this.amount) / (Number(this.taxRate) / 100)).toFixed(2);
        } else if (from == 'taxableAmount' && this.taxRate && this.taxableAmount) {
          this.amount = (Number(this.taxableAmount) * (Number(this.taxRate) / 100)).toFixed(2);
        }
      }
    },
    finishClicked() {
      //check for finish
      if (this.distributeEntriesData.length == 0) {
        this.$showAlert('error', 'No Distribute Entries', 'Must have entries added before clicking on finish');
        return;
      }
      if (this.totalDebit != this.totalCredit) {
        this.$showAlert('error', 'Amount Not Tally', 'Total debit and total credit for distribution must be tally');
        return;
      }

      let entAction = '';
      if (this.entriesButtonTitle.includes('Add')) {
        entAction = 'N';
      } else {
        entAction = 'E';
      }

      const tempData = this.entriesData;
      const tempseqno =
        entAction == 'N' ?
          tempData.length > 0 ?
            Math.max(...tempData.map((m) => Number(m['seqno']))) + 1
          : 1
        : this.selectedEntriesData[0]['seqno'];
      const distEntriesDataObj = {
        '#':
          entAction == 'N' ?
            tempData.length > 0 ?
              Math.max(...tempData.map((m) => Number(m['#']))) + 1
            : 1
          : this.selectedEntriesData[0]['#'],
        // 'Txn Date': this.distributeEntriesData[0]['txndate'],
        'Txn Date': this.distTransactionDate.formatString('yyyy-MM-dd'),
        'Chq No': this.distChequeNo,
        'Voucher No': this.distReceiptVoucherNo,
        // 'Chq No': this.distributeEntriesData[0]['chqno'],
        // 'Voucher No': this.distributeEntriesData[0]['voucherno'],
        'Debit Acc': '',
        'Credit Acc': '',
        Amount: this.distributeEntriesData
          .filter((f) => f['Debit Acc'] != '0')
          .map((m) => Number(m['Amount']))
          .reduce((a, b) => a + b, 0),
        'Job No': this.distributeEntriesData[0]['Job No'],
        Remarks: this.distributeEntriesData[0]['Remarks'],
        'Cost Code': this.distributeEntriesData[0]['Cost Code'],
        'Vehicle No': this.distributeEntriesData[0]['Vehicle No'],
        'Taxable Amt': this.distributeEntriesData
          .filter((f) => f['Debit Acc'] != '0')
          .map((m) => Number(m['Taxable Amt']))
          .reduce((a, b) => a + b, 0),
        'Tax Code': this.distributeEntriesData[0]['Tax Code'],
        'Tax Rate': this.distributeEntriesData[0]['Tax Rate'],
        'Acc Desc': this.distributeEntriesData[0]['Acc Desc'],
        distid: tempseqno,
        updind: '',
        action: '',
        userid: '',
        seqno: tempseqno,
        dateupdated: '',
        batchno: '',
        distributeArr: this.distributeEntriesData.map((m) => {
          return {
            '#': m['#'],
            'Credit Acc': m['Credit Acc'],
            'Debit Acc': m['Debit Acc'],
            Amount: m['Amount'],
            'Job No': m['Job No'],
            Remarks: m['Remarks'],
            'Cost Code': m['Cost Code'],
            'Vehicle No': m['Vehicle No'],
            'Taxable Amt': m['Taxable Amt'],
            'Tax Code': m['Tax Code'],
            'Tax Rate': m['Tax Rate'],
            'Acc Desc': m['Acc Desc'],
            seqno: m['seqno'],
          };
        }),
      };

      if (entAction == 'E' && this.selectedEntriesData.length > 0) {
        const index = tempData.findIndex((item) => item['seqno'] == this.selectedEntriesData[0]['seqno']);
        tempData.splice(index, 1, distEntriesDataObj);
      } else {
        tempData.push(distEntriesDataObj);
      }

      // this.entriesData = [];
      this.updateEntriesTableData(tempData);
      this.$nextTick(() => {
        // this.entriesData = tempData;
        this.batchDateDisabled = true;
        this.showEntriesInput = false;
        this.calculateAccumulated();
      });
    },
    debitSelected(gl) {
      if (this.distributeCheck && gl && gl['Account Code'] != '0') {
        this.selectedCreditAcc = this.glList.getSelected('0', 'Account Code');
      }
    },
    creditSelected(gl) {
      if (this.distributeCheck && gl && gl['Account Code'] != '0') {
        this.selectedDebitAcc = this.glList.getSelected('0', 'Account Code');
      }
    },
    async entriesTableBoxColumnrOrder() {
      const columnOrderID = {
        formname: 'FRMJOURNALENTRY',
        formctrlname: 'JournalEntries',
      };
      const columnOrder = await this.$apiCallV2('/TableBox/GetColumnOrder', columnOrderID);
      this.entriesTableBoxColumnOrderViews = columnOrder;
      this.entriesTableBoxColumnOrderID = columnOrderID;
    },
    async distEntriesTableBoxColumnOrder() {
      const columnOrderID = {
        formname: 'FRMJOURNALENTRY',
        formctrlname: 'DistJournalEntries',
      };
      const columnOrder = await this.$apiCallV2('/TableBox/GetColumnOrder', columnOrderID);
      this.distributeEntriesTableBoxColumnOrderViews = columnOrder;
      this.distributeEntriesTableBoxColumnOrderID = columnOrderID;
    },
    updateEntriesTableData(tableData) {
      this.showEntriesData = false;
      this.entriesData = [];
      this.selectedEntriesData = [];
      const columnOrder = this.entriesTableBoxColumnOrderViews;
      const columnOrderID = this.entriesTableBoxColumnOrderID;
      this.entriesTableBoxColumnOrderViews = [];
      this.entriesTableBoxColumnOrderID = null;

      this.$nextTick(() => {
        this.entriesData = tableData;
        this.entriesTableBoxColumnOrderViews = columnOrder;
        this.entriesTableBoxColumnOrderID = columnOrderID;
        this.showEntriesData = true;
      });
    },
    updateDistEntriesTableData(tableData) {
      this.showDistributeEntriesData = false;
      this.distributeEntriesData = [];
      this.selectedDistributeEntries = [];
      const columnOrder = this.distributeEntriesTableBoxColumnOrderViews;
      const columnOrderID = this.distributeEntriesTableBoxColumnOrderID;
      this.distributeEntriesTableBoxColumnOrderViews = [];
      this.distributeEntriesTableBoxColumnOrderID = null;

      this.$nextTick(() => {
        this.distributeEntriesData = tableData;
        this.distributeEntriesTableBoxColumnOrderViews = columnOrder;
        this.distributeEntriesTableBoxColumnOrderID = columnOrderID;
        this.showDistributeEntriesData = true;
      });
    },
  },
  async mounted() {
    await this.sasControlFunction();

    this.costCodeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'COSTCODE' });
    this.vehicleList = await this.$apiCallV2('/FINGLJournal/GetFINGLList', { masterfile: 'VEHICLE' });
    this.taxList = await this.$apiCallV2('/FINGLJournal/GetFINGLList', { masterfile: 'TAXCODE' });

    await this.entriesTableBoxColumnrOrder();
    await this.distEntriesTableBoxColumnOrder();
    await this.refreshClicked();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.finGLJournal-main {
  display: flex;
  font-size: 12px;
  padding: 10px 45px;

  > .left-container {
    display: flex;
    justify-content: center;
  }

  > .right-container {
    width: 100%;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    > .top-section,
    > .bottom-section {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
    }

    > .top-section {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 38px;

      > .filter-description {
        padding-right: 8px;
      }

      > .button-filter-component {
        margin-right: 5px;
        position: relative;
      }
    }

    > .bottom-section {
      height: 100%;
      margin-top: 5px;
    }
  }
}

.fingljournal-entries {
  height: 100%;
  display: flex;
  flex-direction: column;

  .fingljournal-header {
    display: flex;
    flex-direction: row;

    > .fingljournal-header-left {
      height: 100%;
      width: 60%;
      padding: 5px;

      > .fingljournal-header-left-top {
        display: flex;
        flex-direction: row;
        gap: 5px;
      }
    }

    > .fingljournal-header-right {
      height: 100%;
      width: 40%;
      padding: 5px;

      > .fingljournal-header-right-top {
        display: flex;
        flex-direction: row;
      }
    }
  }

  > .fingljournal-body {
    margin-top: 5px;
    height: 100%;
    flex: 1;
    display: flex;
    overflow-y: auto;

    > .fingljournal-body-table {
      height: 100%;
      display: flex;
      flex-direction: column;

      > .entries-table {
        flex: 1;
        overflow-y: auto;
      }
    }

    > .side-entries-open {
      height: 100%;
      border-left: 1px solid black;
      display: flex;
      flex-direction: column;
      margin-left: 5px;
      padding-left: 5px;

      > .title-button {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 30px;
        margin: 5px 0px;
        padding: 5px 0px;

        > .side-entries-button {
          display: flex;

          button {
            margin-right: 5px;
            height: fit-content;
          }
        }
      }

      > .body-entries-details {
        width: 100%;
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-right: 5px;

        > .body-entries-details-main {
          width: 100%;
          display: flex;
          flex-direction: row;

          > .body-entries-details-left,
          .body-entries-details-right {
            width: 50%;
          }

          > .body-entries-details-left {
            margin-right: 5px;
          }

          > .body-entries-details-right {
            margin-left: 5px;
            // margin-right: 5px;
          }
        }

        > .body-entries-details-distribute {
          flex: 1 1 0;
          overflow: auto;
          margin-bottom: 5px;
        }

        > .body-entries-details-distribute-total {
          display: flex;
          flex-direction: row;
          gap: 10px;
        }
      }
    }
  }
}
</style>
